interface IEmployeeSettings {
	system: string;
	employeeId: number;
	showInSchedule: boolean;
	approveTimeReport: boolean;
	requestAbsenceTypes?: string[];
	reportAbsenceTypes?: string[];
}

export class EmployeeSettings {
	readonly system: string;
	readonly employeeId: number;
	readonly showInSchedule: boolean;
	readonly approveTimeReport: boolean;
	readonly requestAbsenceTypes?: string[];
	readonly reportAbsenceTypes?: string[];
	constructor(values: IEmployeeSettings, system: string) {
		this.system = system;
		this.employeeId = values.employeeId;
		this.showInSchedule = values.showInSchedule;
		this.approveTimeReport = values.approveTimeReport;
		this.requestAbsenceTypes = values.requestAbsenceTypes;
		this.reportAbsenceTypes = values.reportAbsenceTypes;
	}

	hasRequestAbsenceType() {
		return this.requestAbsenceTypes && this.requestAbsenceTypes.length > 0;
	}
	hasReportAbsenceType() {
		return this.reportAbsenceTypes && this.reportAbsenceTypes.length > 0;
	}
}
